import { METRIKA_COUNTER_ID } from '../analytics/AnalyticScript';

export interface AnalyticsParams {
  event: string;
  sourcePage: string;
  sourceComponent?: string;
  name?: string;
  result?: string;
  percent?: string;
}

export default function pushAnalyticsEvent(data: AnalyticsParams): void {
  if (typeof window === 'undefined') return;

  // ym уже готов — стреляем сразу
  if (typeof window.ym === 'function') {
    window.ym(METRIKA_COUNTER_ID, 'reachGoal', data.event ?? 'event', data);

    return;
  }

  // иначе — складируем в очередь, флашнется после init
  const w = window;
  w.__ymq = w.__ymq || [];
  w.__ymq.push({ t: 'goal', args: [data.event ?? 'event', data] });
}
